var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.344 18.429A6.852 6.852 0 0 0 12 5.143a6.853 6.853 0 0 0-2.344 13.285h.343a1.15 1.15 0 0 0 1.144-1.174v-3.968h-1.35c-.437 0-.793-.386-.793-.857c0-.472.356-.858.793-.858h4.414c.437 0 .793.386.793.857c0 .472-.356.858-.793.858h-1.35v3.968a1.196 1.196 0 0 0 1.2 1.174zM12 10.285a1.714 1.714 0 1 0 0-3.429a1.714 1.714 0 0 0 0 3.429m-4.714 3a.857.857 0 1 0 0-1.714a.857.857 0 0 0 0 1.714m10.286-.857a.857.857 0 1 1-1.714 0a.857.857 0 0 1 1.713 0",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaps);
export default __webpack_public_path__ + "static/media/caps.352b75dbf677f952a99a2c10b44372b3.svg";
export { ForwardRef as ReactComponent };